var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"u-main l-view l-container--full-height c-frame"},[_c('div',{staticClass:"l-row"},[_c('div',{staticClass:"l-container l-container--glow"},[_c('FilterIFrame')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }